// recently viewed
(function() {
  if (window.location.pathname.includes('/products/')) {
    const handle = window.location.pathname.split('/products/')[1].split('/')[0];
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

    // Remove duplicates
    recentlyViewed = recentlyViewed.filter(item => item !== handle);

    recentlyViewed.unshift(handle); // Add current product to the beginning
    recentlyViewed = recentlyViewed.slice(0, 8); // Limit to 8 recent items

    localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
  }
})();

// 商品詳細展示店舗一覧
document.addEventListener('DOMContentLoaded', function () {
  const openButton = document.querySelector('[data-modal-open]');
  if (!openButton) return;
  const modal = document.querySelector(openButton.dataset.modalOpen);
  const closeButton = modal.querySelector('.exhibition_store__modal_close');

  // モーダルを開く
  openButton.addEventListener('click', () => {
    if (typeof modal.showModal === "function") {
      modal.showModal();
    }
  });

  // モーダルを閉じる
  closeButton.addEventListener('click', () => {
    modal.close();
  });

  // 背景クリックで閉じる
  modal.addEventListener('click', (event) => {
    const rect = modal.getBoundingClientRect();
    const isInDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;

    if (!isInDialog) {
      modal.close();
    }
  });
});

// 商品購入規約チェックボックス
document.addEventListener('DOMContentLoaded', function(event) {
  const targetButton = document.querySelector('.product-form__cart-submit');
  const triggerCheckbox = document.querySelector('input[name="agree"]');
  if (!triggerCheckbox) return;

  targetButton.addEventListener('click', function(event) {
    if (!triggerCheckbox.checked) {
      alert("商品購入規約に同意する必要があります");
      event.preventDefault();
    }
  });
}, false);

// 受注生産注意事項チェックボックス
document.addEventListener('DOMContentLoaded', function(event) {
  const targetButton = document.querySelector('.product-form__cart-submit');
  const triggerCheckbox = document.querySelector('input[name="agree_order"]');
  if (!triggerCheckbox) return;

  targetButton.addEventListener('click', function(event) {
    if (!triggerCheckbox.checked) {
      alert("受注生産品についてのご注意に同意する必要があります");
      event.preventDefault();
    }
  });
}, false);

// 再入荷ボタンの非表示
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const addButton = document.querySelector('[name="add"]');
    const stockButton = document.querySelector('.gw-button-widget');
    if (addButton && stockButton && addButton.dataset.backInStock === "true") {
      stockButton.style.display = "none";
    }
  }, 2000);
});

//外部サイトリンクの開き方
var links = document.links;
 for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].closest('.HeroSlider')) continue;
  if (links[i].hostname !== window.location.hostname) {
   links[i].target = '_blank';
   links[i].rel = 'noreferrer noopener';
  }
 }

// bodyにslugのクラス付与
document.addEventListener('DOMContentLoaded', function () {
  const path = window.location.pathname;
  const slug = path === '/' ? 'home' : path.replace(/\/$/, '').split('/').pop();

  // batrandomクラスを除外
  if (slug !== 'batrandom') {
    document.body.classList.add(`${slug}`);
  }
});

// アナウンスメントバーのスクロール機能
document.addEventListener('DOMContentLoaded', function () {
  const announcementWrappers = document.querySelectorAll('.announcement-bar__announcements-wrapper-custom');
  
  announcementWrappers.forEach(wrapper => {
    const brandList = wrapper.querySelector('.brand-list');
    const leftArrow = wrapper.querySelector('.announcement-bar__scroll-arrow--left');
    const rightArrow = wrapper.querySelector('.announcement-bar__scroll-arrow--right');
    
    if (!brandList || !leftArrow || !rightArrow) return;
    
    const scrollAmount = 200; // スクロール量
    
    // 左矢印クリック
    leftArrow.addEventListener('click', () => {
      brandList.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });
    
    // 右矢印クリック
    rightArrow.addEventListener('click', () => {
      brandList.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });
    
    // スクロール位置に応じて矢印の表示/非表示を制御
    function updateArrowVisibility() {
      const isAtStart = brandList.scrollLeft <= 0;
      const isAtEnd = brandList.scrollLeft >= brandList.scrollWidth - brandList.clientWidth;
      
      leftArrow.disabled = isAtStart;
      rightArrow.disabled = isAtEnd;
    }
    
    // 初期状態とスクロール時に矢印の状態を更新
    updateArrowVisibility();
    brandList.addEventListener('scroll', updateArrowVisibility);
    
    // リサイズ時にも更新
    window.addEventListener('resize', updateArrowVisibility);
  });
});

// 汎用：コピー・ボタン（本文はサニタイズされるのでテーマ側でイベント委任）
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.btn-copy[data-target], .btn-copy[data-copy]');
  if (!btn) return;

  const feedback = btn.parentElement.querySelector('.copy-feedback');
  const targetSel = btn.getAttribute('data-target');
  const direct = btn.getAttribute('data-copy');
  const el = targetSel ? document.querySelector(targetSel) : null;
  const text = (direct ?? (el ? (el.textContent || el.value || '').trim() : '')).trim();

  if (!text) { if (feedback) feedback.textContent = 'コピー対象が見つかりません'; return; }

  try {
    await navigator.clipboard.writeText(text);
    if (feedback) { feedback.textContent = 'コピーしました'; setTimeout(()=>feedback.textContent='',2000); }
    return;
  } catch (_) { /* fallbackへ */ }

  try {
    const ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly','');
    ta.style.position='fixed'; ta.style.top='-9999px';
    document.body.appendChild(ta); ta.select();
    document.execCommand('copy'); document.body.removeChild(ta);
    if (feedback) { feedback.textContent = 'コピーしました'; setTimeout(()=>feedback.textContent='',2000); }
  } catch (err) {
    if (feedback) feedback.textContent = 'コピーに失敗しました';
  }
});

// ランキングのキャッチコピー高さ揃え（行ごと。全て1行なら1行のまま）
(function () {
  // 表示中のグリッド1つの中で、行ごとに高さを揃える
  function equalizeGrid(grid) {
    // 非表示（別タブ）のグリッドは測定できないのでスキップ
    if (!grid || grid.offsetParent === null) return;

    const items = grid.querySelectorAll('.product-item__catchcopy');
    if (!items.length) return;

    // 一旦リセットして自然な高さを測る
    items.forEach((el) => { el.style.height = 'auto'; });

    // 同じ行（product-item の上端が同じ）ごとにグループ化
    const rows = new Map();
    items.forEach((el) => {
      const item = el.closest('.product-item') || el;
      const top = Math.round(item.getBoundingClientRect().top);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(el);
    });

    // 各行で最も高いキャッチコピーに揃える
    rows.forEach((group) => {
      const max = Math.max.apply(null, group.map((el) => el.offsetHeight));
      group.forEach((el) => { el.style.height = max + 'px'; });
    });
  }

  function equalizeAll() {
    document.querySelectorAll('.product-item-holder').forEach(equalizeGrid);
  }

  const run = () => requestAnimationFrame(equalizeAll);

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  });

  // タブ切替（テンプレートから内容が差し込まれる／activeクラスが変わる）や
  // スライダー再構築などで DOM が変化したら、その都度再計算する
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-section-type="tabbed-collections"]');
    if (!sections.length) return;

    const observer = new MutationObserver(function () {
      // 連続変化をまとめて1回だけ処理
      clearTimeout(observer._t);
      observer._t = setTimeout(run, 60);
    });

    sections.forEach(function (section) {
      observer.observe(section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  });
})();

// Judge.me 返信を2行に省略して「開く」ボタンを付ける
(() => {
  function clampReply(reply) {
    if (reply.dataset.clamped) return;

    const content = reply.querySelector('.jdgm-rev__reply-content');
    if (!content) return;

    // ponytail: ウィジェットが非表示のまま挿入される場合があるので、測れるまでフラグを立てず次回に回す
    const natural = content.getBoundingClientRect().height;
    if (!natural) return;

    reply.dataset.clamped = 'true';
    content.classList.add('jdgm-reply-clamp');
    if (content.getBoundingClientRect().height >= natural - 1) return; // 2行以内なら不要

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jdgm-reply-toggle';
    button.textContent = '＋開く';
    button.addEventListener('click', () => {
      const opened = content.classList.toggle('is-open');
      button.textContent = opened ? '−閉じる' : '＋開く';
    });
    reply.appendChild(button);
  }

  const scan = () => document.querySelectorAll('.jdgm-rev__reply').forEach(clampReply);

  // ウィジェットは非同期描画なので初回 + DOM 変化を監視（rAF で1フレームにまとめる）
  scan();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/**
 * Drag with the mouse to scroll any horizontally overflowing container.
 * Adds `is-dragging` to the container while dragging (style the cursor there).
 * ponytail: delegated on document, so it also covers containers rendered later
 * (the active filter chips are re-rendered on every filter change).
 *
 * @param {string} selector CSS selector of the scrollable container(s)
 * @param {number} [threshold=5] px of movement before it counts as a drag, not a click
 */
function enableDragScroll(selector, threshold = 5) {
  document.addEventListener('pointerdown', (event) => {
    if (event.button !== 0 || event.pointerType === 'touch') return; // touch already scrolls natively

    const container = event.target.closest(selector);
    if (!container || container.scrollWidth <= container.clientWidth) return;

    const startX = event.clientX;
    const startScroll = container.scrollLeft;
    let dragged = false;

    const onMove = (e) => {
      const dx = e.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) < threshold) return;
        dragged = true;
        container.classList.add('is-dragging');
      }
      container.scrollLeft = startScroll - dx;
    };

    const onUp = () => {
      document.removeEventListener('pointermove', onMove);
      container.classList.remove('is-dragging');
      if (!dragged) return;

      // Swallow the click that ends a drag so it doesn't remove the chip under the cursor
      const swallow = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      document.addEventListener('click', swallow, { capture: true, once: true });
      // Clean up in case no click ever fires
      setTimeout(() => document.removeEventListener('click', swallow, true), 0);
    };

    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp, { once: true });
    document.addEventListener('pointercancel', onUp, { once: true });
  });
}

enableDragScroll('.active-filters-inner');
